module.exports = {"440881001":"罗州街道办","440881002":"城南街道办","440881003":"城北街道办","440881101":"石城镇","440881102":"新民镇","440881103":"吉水镇","440881104":"河唇镇","440881105":"石角镇","440881106":"良垌镇","440881107":"横山镇","440881108":"安铺镇","440881109":"营仔镇","440881110":"青平镇","440881111":"车板镇","440881112":"高桥镇","440881113":"石岭镇","440881114":"雅塘镇","440881115":"石颈镇","440881116":"长山镇","440881117":"塘蓬镇","440881118":"和寮镇","440881401":"九洲江开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440881.json
// module id = 1829
// module chunks = 0